import { Component, h } from "preact";

import { getEventTrackGA } from "../../helpers/ga";
// import Close from "../icons/close";

import "./SwitchBanner.scss";

export class SwitchBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hide: false,
    };
  }

  fireGa = (action) => {
    const gaEventObject = {
      category: `${this.props.pageType}_${this.props.category}`,
      label: `switch_banner_${action}`,
      action: `${this.props.subcategory}_${this.props.city}`,
    };

    getEventTrackGA(gaEventObject);
  };

  handleLinkClick = () => {
    this.fireGa("clicked");
    setTimeout(() => {
      window.location.href = "https://www.quikr.com/quikrplus/agent";
    }, 300);
  };

  // closeClick = (e) => {
  //   e.stopPropagation();
  //   this.setState({ hide: true });
  //   this.fireGa("closed");
  // };

  render() {
    return (
      <div className={`switchbanner-root ${this.state.hide ? "hide" : ""}`}>
        <button onClick={this.handleLinkClick} type="button">
          Switch to Quikr AI
        </button>
        {/* <div className="close-button" onClick={this.closeClick}>
          <Close class="close" />
        </div> */}
      </div>
    );
  }
}

export default SwitchBanner;



// WEBPACK FOOTER //
// ../q-components/components/SwitchBanner/SwitchBanner.js